const clientStartup = require('./gral/clientStartup');

clientStartup({
  //routes: require('./gral/routesOldRemove'),
  getRootComponent() {
    return require('@flux/FluxRouter').default;
  },
});
